import { render, staticRenderFns } from "./Shopcat.vue?vue&type=template&id=1d703f72&scoped=true"
import script from "./Shopcat.vue?vue&type=script&lang=js"
export * from "./Shopcat.vue?vue&type=script&lang=js"
import style0 from "./Shopcat.vue?vue&type=style&index=0&id=1d703f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d703f72",
  null
  
)

export default component.exports